import React from 'react';
import WrappedBase from './WrappedBase';

import FlashMessages from 'common/containers/FlashMessages';

export default class FlashMessagesWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <FlashMessages />
      </WrappedBase>
    );
  }
}
